import { useEffect, useState } from "react";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { Footer } from "../../../../layouts/footer";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";

export const AboutUs = () => {
  const aboutUs = useAppSelector((state) => state.FooterDataState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ResponsiveAppBar />
      <div
        id="wrapper"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <div className="tf-page-title style-3">
          <div className="container-full">
            <div className="heading text-center">About Us</div>
          </div>
        </div>
        <section className="flat-spacing-9">
          <div className="container">
            <div className="flat-title my-0">
              {/* <span className="title">We are Navya Bakers</span> */}
              {/* <p className="sub-title text_black-2">
                {aboutUs?.aboutUs?.data?.data?.about_us}
              </p> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: aboutUs?.aboutUs?.data?.data?.about_us,
                }}
              />
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};
